import { styled } from "styled-components";

export const MyReceiptTitleStyled = styled.div`
  font-size: 24px;
  font-weight: 600;
`;
